var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"oral-service-modal-service-container oral-service-modal-featured-service-container card\" ng-class=\"{'active': $ctrl.active}\">\n<div class=\"row\">\n<div class=\"col-xs-10\">\n<div class=\"oral-service-name oral-featured-service-name\">\n{{$ctrl.service.name}}\n</div>\n</div>\n<div class=\"col-xs-2 card-info-icon\" ng-click=\"$ctrl.onServiceInfoClicked($event)\">\n<span class=\"icon icon-26 icon-i pull-right\"></span>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-xs-12\">\n<div class=\"oral-featured-service-description\">\n{{$ctrl.service.description}}\n</div>\n</div>\n</div>\n</div>\n";
var id1="app/services/featured-service-card-info.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/services/featured-service-card-info.tpl.html
// module id = 547
// module chunks = 5